
<div class="page-container" [ngClass]="{'collapsed': isMenuCollapsed}">
    <app-side-menu (collapsedChange)="onMenuCollapsedChange($event)"></app-side-menu>
    <div class="route">
        <router-outlet></router-outlet>
    </div>
</div>